// Phillip Justus ADUC Portfolio - Domain Tree & Object Contents
// Domain: philjustus.local

export const DOMAIN_NAME = 'philjustus.local';

export const OBJECT_TYPES = {
  OU: 'Organizational Unit',
  USER: 'User',
  GROUP: 'Security Group - Global',
  COMPUTER: 'Computer',
  CONTAINER: 'Container',
  DOMAIN: 'Domain',
};

// Tree shown in left pane
export const treeData = {
  id: 'root',
  name: 'Active Directory Users and Computers [DC01.philjustus.local]',
  type: 'ROOT',
  expanded: true,
  children: [
    { id: 'saved-queries', name: 'Saved Queries', type: 'SAVED_QUERIES', expanded: false, children: [] },
    {
      id: 'domain',
      name: 'philjustus.local',
      type: 'DOMAIN',
      expanded: true,
      children: [
        { id: 'builtin', name: 'Builtin', type: 'BUILTIN', children: [] },
        { id: 'computers', name: 'Computers', type: 'CONTAINER', children: [] },
        { id: 'dc', name: 'Domain Controllers', type: 'OU', description: 'Managed by Domain Admins only', children: [] },
        {
          id: 'users',
          name: 'Users',
          type: 'CONTAINER',
          children: [
            { id: 'profile', name: 'Profile', type: 'OU', description: 'Professional roles held / qualified for', children: [] },
            { id: 'certifications', name: 'Certifications', type: 'OU', description: 'Professional certifications', children: [] },
          ],
        },
        {
          id: 'skills',
          name: 'Skills',
          type: 'OU',
          description: 'Technical skills and competencies',
          children: [
            { id: 'skills-grc', name: 'GRC & Compliance', type: 'OU', children: [] },
            { id: 'skills-defensive', name: 'Defensive Security', type: 'OU', children: [] },
            { id: 'skills-vuln', name: 'Vulnerability Management', type: 'OU', children: [] },
            { id: 'skills-infra', name: 'Infrastructure', type: 'OU', children: [] },
            { id: 'skills-cloud', name: 'Cloud Security', type: 'OU', children: [] },
            { id: 'skills-auto', name: 'Automation & Scripting', type: 'OU', children: [] },
          ],
        },
        { id: 'areas', name: 'Areas of Expertise', type: 'OU', description: 'Core focus areas', children: [] },
        { id: 'education', name: 'Education', type: 'OU', description: 'Academic & professional development', children: [] },
      ],
    },
  ],
};

// Members list for Phillip Justus (built dynamically below from groups)
const ALL_AREAS = [
  'Cybersecurity Engineering','Product & Portfolio Development','Enterprise Infrastructure & Network Mgmt',
  'Business Continuity / Disaster Recovery','Cybersecurity Tools','Regulatory Compliance',
  'Risk Assessment & Mitigation','Incident Response','Identity and Access Management (IAM)',
  'Project Management','Software Development Lifecycle (SDLC)','Technical Testing & Troubleshooting',
];

const ALL_SKILL_GROUPS = [
  // GRC
  'NIST SP 800-53 / RMF','NIST CSF','ISO 27001 / 27002','NISPOM / DAAPM / JSIG','DD254 / Contract Security',
  'Security Artifacts (SCTM/POA&M/SSP/RAR/IA SOP)','ATO & Continuous Monitoring','CMMC 2.0','eMASS / CSAM','FedRAMP',
  // Defensive
  'Splunk Enterprise','Security Event Auditing','Incident Response (Defensive)','Forensic Analysis','CrowdStrike Falcon',
  'Microsoft Sentinel + KQL','Microsoft Defender XDR','MITRE ATT&CK','Threat Intelligence',
  // Vuln
  'Nessus / Tenable.sc','ACAS (DISA)','STIG / SCAP','SCAP Compliance Checker','Vulnerability Remediation / POA&M',
  'Patch Management','CVSS / CVE Triage',
  // Infra
  'Windows Server (2008-2025)','Active Directory','Group Policy (GPO)','Linux (RHEL / Ubuntu)',
  'Networking (TCP/IP, VLAN, VPN)','Servers / Routers / Switches','Encryption Devices','VMware vSphere / Hyper-V',
  'Business Continuity / DR (Infra)',
  // Cloud
  'Cloud Security Architecture','Identity & Access Management','Microsoft Azure / Entra ID','AWS Security',
  'Zero Trust Architecture','Cloud Data Security',
  // Automation
  'PowerShell Scripting','Python','Bash','Infrastructure as Code','CI/CD Security',
];

const EDUCATION_GROUPS = [
  'Associates - Computer Science (in progress)',
  'Cyber Operations Tech School (Keesler AFB)',
];

// Phillip's full memberOf list
export const PHILLIP_MEMBER_OF = [
  'Domain Users','Security Admins','ISC2 Members','USAF / ANG Alumni',
  ...ALL_AREAS, ...ALL_SKILL_GROUPS, ...EDUCATION_GROUPS,
];

// Right-pane contents per node
export const nodeContents = {
  root: [
    { id: 'saved-queries', name: 'Saved Queries', type: 'SAVED_QUERIES', description: 'Folder to store your favorite queries' },
    { id: 'domain', name: 'philjustus.local', type: 'DOMAIN', description: '' },
  ],
  'saved-queries': [],
  domain: [
    { id: 'builtin', name: 'Builtin', type: 'BUILTIN', description: '' },
    { id: 'computers', name: 'Computers', type: 'CONTAINER', description: 'Default container for upgraded computer accounts' },
    { id: 'dc', name: 'Domain Controllers', type: 'OU', description: 'Managed by Domain Admins only' },
    { id: 'users', name: 'Users', type: 'CONTAINER', description: 'Default container for upgraded user accounts' },
    { id: 'skills', name: 'Skills', type: 'OU', description: 'Technical skills and competencies' },
    { id: 'areas', name: 'Areas of Expertise', type: 'OU', description: 'Core focus areas' },
    { id: 'education', name: 'Education', type: 'OU', description: 'Academic & professional development' },
  ],
  builtin: [
    { id: 'b-admins', name: 'Administrators', type: 'GROUP', description: 'Administrators have complete and unrestricted access' },
    { id: 'b-users', name: 'Users', type: 'GROUP', description: 'Users are prevented from making accidental changes' },
    { id: 'b-backup', name: 'Backup Operators', type: 'GROUP', description: 'Can override security restrictions for backup' },
    { id: 'b-rd', name: 'Remote Desktop Users', type: 'GROUP', description: 'Granted the right to logon remotely' },
    { id: 'b-print', name: 'Print Operators', type: 'GROUP', description: 'Can administer domain printers' },
    { id: 'b-svr', name: 'Server Operators', type: 'GROUP', description: 'Can administer domain servers' },
  ],
  computers: [
    { id: 'comp-1', name: 'WS-PJUSTUS-01', type: 'COMPUTER', description: 'Primary workstation - admin: Workstation Admins' },
    { id: 'comp-2', name: 'LAB-SPLUNK', type: 'COMPUTER', description: 'Splunk Enterprise lab server - admin: Workstation Admins' },
    { id: 'comp-3', name: 'LAB-NESSUS', type: 'COMPUTER', description: 'Tenable Nessus / ACAS scanner - admin: Workstation Admins' },
    { id: 'comp-4', name: 'LAB-FORENSICS', type: 'COMPUTER', description: 'Forensics & malware analysis - admin: Workstation Admins' },
    { id: 'comp-5', name: 'LAB-PWSH', type: 'COMPUTER', description: 'PowerShell automation / build host - admin: Workstation Admins' },
  ],
  dc: [{ id: 'c-dc01', name: 'DC01', type: 'COMPUTER', description: 'Primary domain controller - managed by Domain Admins only' }],
  users: [
    { id: 'u-admin', name: 'Administrator', type: 'USER', description: 'Built-in account for administering the domain' },
    { id: 'u-guest', name: 'Guest', type: 'USER', description: 'Built-in account for guest access' },
    { id: 'u-me', name: 'Phillip Justus', type: 'USER', description: 'Cyber Engineer / ISSM - Portfolio Owner' },
    { id: 'g-da', name: 'Domain Admins', type: 'GROUP', description: 'Designated administrators of the domain (manage Domain Controllers)' },
    { id: 'g-du', name: 'Domain Users', type: 'GROUP', description: 'All domain users' },
    { id: 'g-ea', name: 'Enterprise Admins', type: 'GROUP', description: 'Designated administrators of the enterprise' },
    { id: 'g-sa', name: 'Schema Admins', type: 'GROUP', description: 'Designated administrators of the schema' },
    { id: 'g-secadmins', name: 'Security Admins', type: 'GROUP', description: 'Cybersecurity administration - Phillip Justus is a member' },
    { id: 'g-wsadmins', name: 'Workstation Admins', type: 'GROUP', description: 'Local admin rights on all workstations and lab hosts' },
    { id: 'profile', name: 'Profile', type: 'OU', description: 'Professional roles held / qualified for' },
    { id: 'certifications', name: 'Certifications', type: 'OU', description: 'Professional certifications' },
  ],
  profile: [
    { id: 'role-cyber-eng', name: 'Cyber Engineer', type: 'USER', description: 'Designs and builds enterprise security capabilities' },
    { id: 'role-grc', name: 'GRC Analyst', type: 'USER', description: 'Governance, Risk, and Compliance practitioner' },
    { id: 'role-iam', name: 'IAM Analyst', type: 'USER', description: 'Identity and Access Management specialist' },
    { id: 'role-issm', name: 'ISSM/ISSO', type: 'USER', description: 'Information System Security Manager / Officer' },
    { id: 'role-sysadmin', name: 'IT System Administrator', type: 'USER', description: 'Enterprise systems administration and operations' },
  ],
  certifications: [
    { id: 'cert-cissp', name: 'CISSP', type: 'USER', description: 'Certified Information Systems Security Professional - ISC2' },
    { id: 'cert-ccsp', name: 'CCSP', type: 'USER', description: 'Certified Cloud Security Professional - ISC2' },
    { id: 'cert-secplus', name: 'CompTIA Security+', type: 'USER', description: 'CompTIA Security+ - DoD 8570 IAT II / IAM I baseline certification' },
    { id: 'cert-als', name: 'Airmen Leadership School', type: 'USER', description: 'USAF PME - prerequisite for Staff Sergeant promotion' },
  ],
  skills: [
    { id: 'skills-grc', name: 'GRC & Compliance', type: 'OU', description: 'Governance, Risk, and Compliance' },
    { id: 'skills-defensive', name: 'Defensive Security', type: 'OU', description: 'Blue team / SOC / detection' },
    { id: 'skills-vuln', name: 'Vulnerability Management', type: 'OU', description: 'Scanning, hardening, STIG/SCAP' },
    { id: 'skills-infra', name: 'Infrastructure', type: 'OU', description: 'Systems and networking' },
    { id: 'skills-cloud', name: 'Cloud Security', type: 'OU', description: 'Azure / AWS security' },
    { id: 'skills-auto', name: 'Automation & Scripting', type: 'OU', description: 'PowerShell, Python, IaC' },
  ],
  'skills-grc': [
    { id: 'grc-1', name: 'NIST SP 800-53 / RMF', type: 'GROUP', description: 'Control selection, tailoring, assessment, continuous monitoring' },
    { id: 'grc-2', name: 'NIST CSF', type: 'GROUP', description: 'Identify / Protect / Detect / Respond / Recover' },
    { id: 'grc-3', name: 'ISO 27001 / 27002', type: 'GROUP', description: 'ISMS controls and practices' },
    { id: 'grc-4', name: 'NISPOM / DAAPM / JSIG', type: 'GROUP', description: 'DoD classified information system security' },
    { id: 'grc-5', name: 'DD254 / Contract Security', type: 'GROUP', description: 'Classified contract guidance implementation' },
    { id: 'grc-6', name: 'Security Artifacts (SCTM/POA&M/SSP/RAR/IA SOP)', type: 'GROUP', description: 'Develop, maintain, and submit required artifacts' },
    { id: 'grc-7', name: 'ATO & Continuous Monitoring', type: 'GROUP', description: 'Authorization to Operate and ConMon lifecycle' },
    { id: 'grc-8', name: 'CMMC 2.0', type: 'GROUP', description: 'Cybersecurity Maturity Model Certification alignment' },
    { id: 'grc-9', name: 'eMASS / CSAM', type: 'GROUP', description: 'DoD compliance management platforms' },
    { id: 'grc-10', name: 'FedRAMP', type: 'GROUP', description: 'Cloud authorization for federal workloads' },
  ],
  'skills-defensive': [
    { id: 'def-1', name: 'Splunk Enterprise', type: 'GROUP', description: 'SIEM, SPL search, dashboards, alerting' },
    { id: 'def-2', name: 'Security Event Auditing', type: 'GROUP', description: 'Weekly OS event-log audits & analysis' },
    { id: 'def-3', name: 'Incident Response (Defensive)', type: 'GROUP', description: 'Containment, eradication, recovery, lessons learned' },
    { id: 'def-4', name: 'Forensic Analysis', type: 'GROUP', description: 'Root-cause & extent determination' },
    { id: 'def-5', name: 'CrowdStrike Falcon', type: 'GROUP', description: 'EDR telemetry, threat hunting, RTR' },
    { id: 'def-6', name: 'Microsoft Sentinel + KQL', type: 'GROUP', description: 'Cloud-native SIEM & Kusto queries' },
    { id: 'def-7', name: 'Microsoft Defender XDR', type: 'GROUP', description: 'Endpoint, Identity, O365, Cloud Apps' },
    { id: 'def-8', name: 'MITRE ATT&CK', type: 'GROUP', description: 'Tactic/technique mapping for detections' },
    { id: 'def-9', name: 'Threat Intelligence', type: 'GROUP', description: 'IOC enrichment, threat-actor profiling' },
  ],
  'skills-vuln': [
    { id: 'vuln-1', name: 'Nessus / Tenable.sc', type: 'GROUP', description: 'Authenticated scanning, plugin tuning, reporting' },
    { id: 'vuln-2', name: 'ACAS (DISA)', type: 'GROUP', description: 'Assured Compliance Assessment Solution' },
    { id: 'vuln-3', name: 'STIG / SCAP', type: 'GROUP', description: 'DISA STIG compliance and SCAP scanning' },
    { id: 'vuln-4', name: 'SCAP Compliance Checker', type: 'GROUP', description: 'Automated STIG benchmark evaluation' },
    { id: 'vuln-5', name: 'Vulnerability Remediation / POA&M', type: 'GROUP', description: 'Track, prioritize, and close findings' },
    { id: 'vuln-6', name: 'Patch Management', type: 'GROUP', description: 'WSUS / SCCM / Intune update rings' },
    { id: 'vuln-7', name: 'CVSS / CVE Triage', type: 'GROUP', description: 'Risk scoring and mitigation planning' },
  ],
  'skills-infra': [
    { id: 'inf-1', name: 'Windows Server (2008-2025)', type: 'GROUP', description: 'Installation, hardening, role deployment' },
    { id: 'inf-2', name: 'Active Directory', type: 'GROUP', description: 'Design, OU structure, tiered admin, trusts' },
    { id: 'inf-3', name: 'Group Policy (GPO)', type: 'GROUP', description: 'Security baselines, WMI filters, preferences' },
    { id: 'inf-4', name: 'Linux (RHEL / Ubuntu)', type: 'GROUP', description: 'Administration, hardening, STIG application' },
    { id: 'inf-5', name: 'Networking (TCP/IP, VLAN, VPN)', type: 'GROUP', description: 'Core networking and secure connectivity' },
    { id: 'inf-6', name: 'Servers / Routers / Switches', type: 'GROUP', description: 'Enterprise infrastructure monitoring' },
    { id: 'inf-7', name: 'Encryption Devices', type: 'GROUP', description: 'Key management and crypto hygiene' },
    { id: 'inf-8', name: 'VMware vSphere / Hyper-V', type: 'GROUP', description: 'Virtualization platforms' },
    { id: 'inf-9', name: 'Business Continuity / DR (Infra)', type: 'GROUP', description: 'BC/DR plans, tabletop exercises, recovery testing' },
  ],
  'skills-cloud': [
    { id: 'cld-1', name: 'Cloud Security Architecture', type: 'GROUP', description: 'CCSP-aligned: design, risk, governance' },
    { id: 'cld-2', name: 'Identity & Access Management', type: 'GROUP', description: 'IAM, MFA, conditional access, PIM' },
    { id: 'cld-3', name: 'Microsoft Azure / Entra ID', type: 'GROUP', description: 'Conditional Access, PIM, identity protection' },
    { id: 'cld-4', name: 'AWS Security', type: 'GROUP', description: 'IAM, GuardDuty, Security Hub, KMS' },
    { id: 'cld-5', name: 'Zero Trust Architecture', type: 'GROUP', description: 'NIST 800-207 implementation patterns' },
    { id: 'cld-6', name: 'Cloud Data Security', type: 'GROUP', description: 'Encryption at rest/in transit, DLP, key mgmt' },
  ],
  'skills-auto': [
    { id: 'aut-1', name: 'PowerShell Scripting', type: 'GROUP', description: 'Audit, automation, reporting scripts' },
    { id: 'aut-2', name: 'Python', type: 'GROUP', description: 'Tooling, log parsing, API automation' },
    { id: 'aut-3', name: 'Bash', type: 'GROUP', description: 'Linux administration automation' },
    { id: 'aut-4', name: 'Infrastructure as Code', type: 'GROUP', description: 'Terraform / Ansible for repeatable hardening' },
    { id: 'aut-5', name: 'CI/CD Security', type: 'GROUP', description: 'Pipeline scanning, secret detection' },
  ],
  areas: [
    { id: 'area-1', name: 'Cybersecurity Engineering', type: 'GROUP', description: 'Core engineering focus' },
    { id: 'area-2', name: 'Product & Portfolio Development', type: 'GROUP', description: 'Security for product lines and portfolios' },
    { id: 'area-3', name: 'Enterprise Infrastructure & Network Mgmt', type: 'GROUP', description: 'Real-time monitoring of critical IT infrastructure' },
    { id: 'area-4', name: 'Business Continuity / Disaster Recovery', type: 'GROUP', description: 'BC/DR planning and execution' },
    { id: 'area-5', name: 'Cybersecurity Tools', type: 'GROUP', description: 'Splunk, Nessus, ACAS, CrowdStrike, STIG/SCAP' },
    { id: 'area-6', name: 'Regulatory Compliance', type: 'GROUP', description: 'NIST, ISO, NISPOM, DAAPM, JSIG' },
    { id: 'area-7', name: 'Risk Assessment & Mitigation', type: 'GROUP', description: 'Identify, analyze, treat, monitor' },
    { id: 'area-8', name: 'Incident Response', type: 'GROUP', description: 'Full IR lifecycle' },
    { id: 'area-9', name: 'Identity and Access Management (IAM)', type: 'GROUP', description: 'Identity governance and access control' },
    { id: 'area-10', name: 'Project Management', type: 'GROUP', description: 'Scope, schedule, cost, quality, stakeholders' },
    { id: 'area-11', name: 'Software Development Lifecycle (SDLC)', type: 'GROUP', description: 'Secure SDLC integration' },
    { id: 'area-12', name: 'Technical Testing & Troubleshooting', type: 'GROUP', description: 'Root-cause analysis and remediation' },
  ],
  education: [
    { id: 'edu-1', name: 'Associates - Computer Science (in progress)', type: 'GROUP', description: 'Some College - Computer Science' },
    { id: 'edu-2', name: 'Cyber Operations Tech School (Keesler AFB)', type: 'GROUP', description: 'USAF Cyber Systems Operations training' },
  ],
};

// Phillip Justus full profile (Properties dialog)
export const objectProperties = {
  'u-me': {
    general: {
      firstName: 'Phillip',
      lastName: 'Justus',
      displayName: 'Phillip Richard Justus',
      description: 'Cyber Engineer / ISSM - 12 Years IT & Cybersecurity',
      office: 'Langhorne, PA',
      telephone: '(215) 868-8981',
      email: 'philjustus@gmail.com',
      webPage: '',
    },
    address: { street: '', city: 'Langhorne', state: 'PA', zip: '19047', country: 'United States' },
    account: {
      logonName: 'pjustus',
      logonNamePre: 'PHILJUSTUS\\pjustus',
      accountExpires: 'Never',
      passwordLastSet: 'Current',
      accountOptions: [
        'User must change password at next logon: No',
        'Password never expires: No',
        'Account is disabled: No',
      ],
    },
    profile: {
      profilePath: '\\\\DC01\\Profiles$\\pjustus',
      logonScript: 'logon.ps1',
      homeFolder: '\\\\DC01\\Users$\\pjustus',
    },
    memberOf: PHILLIP_MEMBER_OF,
    summary: `Technically advanced and resourceful Cyber Engineer with 12 years of IT and Cybersecurity experience. Proven track record of interpreting and implementing NIST CSF and ISO 27001/27002 controls, procedures, and practices. Well-versed in real-time monitoring of critical IT infrastructure including servers, routers, switches, encryption devices, and workstations. Adept at risk assessment, compliance, incident response, and forensic analysis. Demonstrated expertise in contributing to enhancement of cybersecurity postures through meticulous analysis and proactive measures. Skilled in developing and executing effective GRC strategies.`,
  },
};
